import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_PATIENTS_REQUEST, fetchPatientsSuccess, fetchPatientsFailure,
  CREATE_PATIENT_REQUEST, createPatientSuccess, createPatientFailure,
  UPDATE_PATIENT_REQUEST, updatePatientSuccess, updatePatientFailure,
  DELETE_PATIENT_REQUEST, deletePatientSuccess, deletePatientFailure
} from '../actions/patientActions';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = getBaseUrl();
const authToken = localStorage.getItem('authToken');
const getAuthToken = () => localStorage.getItem('authToken');

const createConfig = () => ({
  headers: { 'Authorization': `Bearer ${authToken}` }
});

function* fetchPatients(action) {
  try {
    const token = getAuthToken();
    const { projectId, page = 1, limit = 1, search = '', group = '' } = action.payload || {};
    
    console.log("Fetching patient with payload: ", action.payload);

    const response = yield call(
      axios.get,
      `${getBaseUrl()}/${projectId}/patient`, // Updated endpoint
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit, search, group },
      }
    );

    // Expecting `data` and `meta` in the response
    yield put(fetchPatientsSuccess(response.data));
  } catch (error) {
    console.error("Error fetching patient: ", error);
    yield put(fetchPatientsFailure(error.response?.data?.message || error.message));
  }
}

function* createPatient(action) {
  try {
    console.log(action.payload);
    const response = yield call(axios.post, `${API_BASE_URL}/${action.payload.projectId}/patient`, action.payload.data, createConfig());
    yield put(createPatientSuccess(response.data));
  } catch (error) {
    yield put(createPatientFailure(error.message));
  }
}

function* updatePatient(action) {
  try {
    const { id, data,projectId } = action.payload;
    console.log()
    const response = yield call(axios.put, `${API_BASE_URL}/${projectId}/patient/${id}`, data, createConfig());
    yield put(updatePatientSuccess(response.data));
  } catch (error) {
    yield put(updatePatientFailure(error.message));
  }
}

function* deletePatient(action) {
  try {
    const { id,projectId } = action.payload;
    yield call(axios.delete, `${API_BASE_URL}/${projectId}/patient/${id}`, createConfig());
    yield put(deletePatientSuccess(id));
  } catch (error) {
    yield put(deletePatientFailure(error.message));
  }
}

export default function* patientSaga() {
  yield takeLatest(FETCH_PATIENTS_REQUEST, fetchPatients);
  yield takeLatest(CREATE_PATIENT_REQUEST, createPatient);
  yield takeLatest(UPDATE_PATIENT_REQUEST, updatePatient);
  yield takeLatest(DELETE_PATIENT_REQUEST, deletePatient);
}
